import { EnumInterface } from '@/domain/interface/intern/enumvalues/EnumInterface';
import { MeldingClass } from '../melding/MeldingClass';
import { StatusEnum } from '@/domain/interface/activiteit/StatusEnum';
import { ActiviteitTypeEnum } from '@/domain/interface/activiteit/ActiviteitTypeEnum';
import { WarningMessage } from '@/store/modules/warningAlertMessages';

export class ActiviteitClass extends MeldingClass {
  activiteitType?: EnumInterface;
  verwarmingType?: EnumInterface;
  datumActiviteit: Date;
  datumStatus: Date;
  activiteitStatus: EnumInterface | undefined;
  uitvoerenDoorOwnerMogelijk?: boolean;
  melder?: string;
  erkenningsnummer?: string;
  activiteitOwner?: boolean;
  activiteitErkendeTechnicus?: boolean;
  eindbeoordelingKeuringIngevuld?: boolean;
  brandstofTypeIsGekend?: boolean;
  erkendeTechnicusInvulbaar?: boolean;
  showErkendeTechnicusVelden?: boolean;
  opmerkingen: WarningMessage[];

  constructor(activiteit?: ActiviteitClass) {
    super(activiteit);
    this.activiteitStatus = activiteit?.activiteitStatus || undefined;
    this.activiteitType = activiteit?.activiteitType;
    this.datumActiviteit = activiteit?.datumActiviteit;
    this.datumStatus = activiteit?.datumStatus;
    this.verwarmingType = activiteit?.verwarmingType;
    this.uitvoerenDoorOwnerMogelijk = activiteit?.uitvoerenDoorOwnerMogelijk;
    this.melder = activiteit?.melder;
    this.erkenningsnummer = activiteit?.erkenningsnummer;
    this.activiteitOwner = activiteit?.activiteitOwner;
    this.activiteitErkendeTechnicus = activiteit?.activiteitErkendeTechnicus;
    this.readOnly = activiteit?.readOnly || false;
    this.eindbeoordelingKeuringIngevuld = activiteit?.eindbeoordelingKeuringIngevuld;
    this.brandstofTypeIsGekend = activiteit?.brandstofTypeIsGekend;
    this.erkendeTechnicusInvulbaar = activiteit?.erkendeTechnicusInvulbaar;
    this.showErkendeTechnicusVelden = activiteit?.showErkendeTechnicusVelden;
    this.opmerkingen = activiteit?.opmerkingen;
  }

  isInFinaleStatus() {
    return StatusEnum.INGEDIEND === this.activiteitStatus?.code || StatusEnum.GEVALIDEERD_EN_INGEDIEND === this.activiteitStatus?.code;
  }

  isDatumActiviteitInDeToekomst() {
    return new Date(this.datumActiviteit) > new Date();
  }

  isInTeValiderenStatus() {
    return StatusEnum.TE_VALIDEREN === this.activiteitStatus?.code;
  }

  isInTeValiderenStatusAndErkendeTechnicus() {
    return StatusEnum.TE_VALIDEREN === this.activiteitStatus?.code && this.activiteitErkendeTechnicus;
  }

  isInInBewerkingStatus() {
    return StatusEnum.IN_BEWERKING === this.activiteitStatus?.code;
  }

  isInGeweigerdStatus() {
    return StatusEnum.GEWEIGERD === this.activiteitStatus?.code;
  }

  isInBewerkingStatusOfTeValideren() {
    return this.isInInBewerkingStatus() || this.isInTeValiderenStatus();
  }

  isWizardHomeKnopVisible() {
    return this.isInFinaleStatus() || this.isInTeValiderenStatus();
  }

  isActiviteitTypeOnderhoud() {
    return ActiviteitTypeEnum.ONDERHOUD_STOOKTOESTEL === this.activiteitType?.code;
  }
}
